import React from 'react'

export default function PageNotFound() {
    return (
        <main className='px-6 flex flex-col justify-center xl:snap-start h-screen'>
            <section className='container'>
                <div>
                    <h1 className='text-5xl text-secondary font-bold mb-1 xl:text-7xl mt-8'>404 error. <br /><span className='features-explanation'>(⌐■_■) umm... this page might not exist.</span></h1>
                </div>
            </section>
        </main>
    )
}
